import { defineStore } from 'pinia'
import {
    type ToastData,
    type UiStoreActions,
    type UiStoreGetters,
    type UiStoreState,
} from '@/types'

export const useUiStore = defineStore<'ui', UiStoreState, UiStoreGetters, UiStoreActions>('ui', {
    state: (): UiStoreState => ({
        isLoading: false,
        toast: {
            detail: '',
            id: 0,
            severity: 'info',
            summary: '',
        },
    }),
    actions: {
        setLoading(value: boolean) {
            this.isLoading = value
        },
        setToastData(summary: string, detail?: string): void {
            this.toast.summary = summary
            this.toast.detail = detail || ''
            this.toast.id++
        },
        showError(...args: ToastData): void {
            this.toast.severity = 'warn'
            this.setToastData(...args)
        },
        showInfo(...args: ToastData) {
            this.toast.severity = 'info'
            this.setToastData(...args)
        },
        showSuccess(...args: ToastData): void {
            this.toast.severity = 'success'
            this.setToastData(...args)
        },
    },
})
